<template>
  <section class="show-background" :style="preview ? 'margin-top: 0' : ''">
    <div class="show-title finished" v-if="!loading && !show.dates.length > 0">Este evento já foi realizado</div>
    <div class="show-container">
      <div v-if="backImage" class="show-image" :style="`background-image: url(${backImage})`"></div>
      <!-- <transition name="pop" mode="out-in"> -->
      <div v-show="paying" class="loading-pay" key="loading-pay">
        <i class="fas fa-spinner loading"></i>
        <span>Processando pagamento</span>
      </div>
      <div v-if="!loading" v-show="!paying" class="show-detail" id="show-align" key="show-align">
        <!-- SHOW -->
        <div style="flex-grow: 1">
          <div class="show-title">{{ show.name || '' }}</div>
          <div class="show-type" style="margin-bottom: 5px">
            {{ show.type || '' }}
            <span style="padding: 0 5px">|</span>
            {{ show.duration || '0' }} min
            <span style="padding: 0 5px">|</span>
            <div v-if="show.minPrice">
              <span v-if="!show.online"> Ingressos a partir de</span> R$ {{ show.minPrice.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
            </div>
          </div>
        </div>
        <transition name="pop" mode="out-in">
          <div v-if="timer" key="timer" class="show-timer">{{ timerText }}</div>
          <div v-else key="sensor" style="display: flex;">
            <div class="show-censor" :class="`censor-${show.censor}`">{{ show.censor === 0 ? 'L' : show.censor }}</div>
            <div v-if="show.censorFollowed" class="show-censor" :class="`censor-${show.censorFollowed}`" style="margin-left: 5px">
              {{ show.censorFollowed === 0 ? 'L' : show.censorFollowed }}
              <div class="followed">acomp.</div>
            </div>
          </div>
        </transition>
        <!-- DATES -->
        <ShowDate
          v-if="!loading && show.dates.length > 0"
          :step="step"
          :setStep="setStep"
          :show="show"
          :showDate="showDate"
          :finishDate="finishDate"
        />
        <transition-group name="pop" mode="out-in" style="width: 100%">
          <!-- INFO -->
          <ShowDescription
            v-show="!showDate || step < 2"
            :business="business"
            :show="show"
            :preview="preview"
            key="show-info"
          />
          <!-- STAGE -->
          <ShowStage
            v-show="step > 1 && !withoutStage && !show.online"
            :step="step"
            :setStep="setStep"
            :withoutStage="withoutStage"
            :stage="business.stage"
            :showDate="showDate && showDate.id || null"
            :prices="prices"
            :finishStage="finishStage"
            :ticketsReserved="tickets"
            :maxTicketUser="maxTicketUser"
            :preview="preview"
            :withSection="withSection"
            key="show-stage"
          />
          <!-- TICKETS -->
          <ShowTicket
            v-show="step > 2 && !withoutStage && !show.online"
            :step="step"
            :setStep="setStep"
            :withoutStage="withoutStage"
            :tickets="tickets"
            :prices="prices"
            :finishTickets="finishTickets"
            :payment="showPayment"
            :withSection="withSection"
            key="show-tickets"
          />
          <!-- TICKETS NO STAGE -->
          <ShowTicketNoStage
            v-show="step > 2 && (withoutStage || show.online)"
            :step="step"
            :setStep="setStep"
            :show="show"
            :withoutStage="withoutStage"
            :showDate="showDate && showDate.id || null"
            :payment="showPayment"
            :prices="prices"
            :maxTicketUser="maxTicketUser"
            :ticketsReserved="tickets"
            :finishNoStage="finishNoStage"
            :preview="preview"
            key="show-no-stage"
          />
          <!-- FORMA DE PAGAMENTO -->
          <ShowPayment
            v-show="step > 3 && Number(total) > 0"
            :step="step"
            :setStep="setStep"
            :showPayment="showPayment"
            :total="total"
            :finishPayment="finishPayment"
            :preview="preview"
            :customer="customer"
            :error="error"
            key="show-payment"
          />
          <!-- CONFIRMAR -->
          <div v-if="!loading && step === 5" key="show-confirm">
            <button @click="buyTickets" type="button" class="button-confirm"><i class="fas fa-check"></i><span>Confirmar</span></button>
          </div>
        </transition-group>
                <!-- DATES -->
        <ShowDate
          v-if="!loading && show.dates.length > 0"
          v-show="step < 2"
          :step="step"
          :setStep="setStep"
          :show="show"
          :showDate="showDate"
          :finishDate="finishDate"
        />
        <!-- Error Message  -->
        <div v-if="error.indexOf('payment-error') > -1 || error.indexOf('payment_method_code') > -1" class="payment-error">
          <i class="fas fa-times"></i>
          <div class="payment-error-msg">
            <span>Não foi possível realizar o pagamento!</span>
            <span>Retorno: {{ errorMsg || 'pagamento não suportado' }}</span>
            <span>Por favor tente novamente.</span>
          </div>
        </div>
      </div>
      <!-- </transition> -->
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ShowStage from './ShowStage.vue'
import ShowPayment from './ShowPayment.vue'
import ShowDescription from './ShowDescription.vue'
import ShowTicket from './ShowTicket.vue'
import ShowDate from './ShowDate.vue'
import logger from '../../logger'
import { get } from '../api/show'
import { get as getBusiness } from '../api/business'
import { get as getShowDate } from '../api/showDate'
import { buy, getAmountPrices } from '../api/ticket'
import { get as getCustomer } from '../api/customer'
import ShowTicketNoStage from './ShowTicketNoStage.vue'

export default {
  name: 'show',
  props: ['id', 'name', 'status', 'businessUrl', 'preview'],
  components: { ShowStage, ShowPayment, ShowDescription, ShowTicket, ShowDate, ShowTicketNoStage },
  data () {
    return {
      API_IMG: process.env.VUE_APP_IMG,
      finished: false,
      error: [],
      errorMsg: null,
      loading: true,
      show: null,
      business: null,
      backImage: null,
      showDate: null,
      prices: [],
      tickets: [],
      timer: null,
      timerText: '00:00',
      timerInterval: null,
      paying: false,
      maxTicketUser: 0,
      showPayment: null,
      payment: {},
      step: 1,
      withoutStage: false,
      withSection: false,
      total: 0,
      customer: null
    }
  },
  computed: {
    ...mapState(['reserved', 'invitations'])
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  },
  async mounted () {
    try {
      this.$store.commit('search', '')
      if (!this.preview) this.$analytics.event('show', this.id)
      // Show and dates
      const show = await get(this.id)
      document.title = `Swiss Money - ${show.name}`
      this.show = show
      this.finished = show.dates.lenght > 0
      // Set show image
      if (show.images) {
        this.backImage = `${this.API_IMG}/${this.show.business}/${this.id}/${show.images[0]}`
        if (!this.preview) {
          const styleElem = document.head.appendChild(document.createElement('style'))
          styleElem.innerHTML = `.show-background:before { background-image: url(${this.backImage}); }`
        }
      }
      // Business
      this.business = await getBusiness(this.show.business)
      // this.$store.commit('city', this.business.addressCity)
      // Check if has reserved tickets
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true)
        }, 1000)
      })
      if (this.reserved && this.reserved.show === Number(this.id) && this.reserved.tickets) {
        this.tickets = this.reserved.tickets.map(x => ({
          seat: x.seat,
          showPrice: x.showPrice,
          section: x.section
        })).sort((a, b) => a.seat - b.seat)
        // Set timer
        this.setTimer(this.reserved.now, this.reserved.tickets[0].created)
        // this.$store.commit('reserved', null)
        this.finishDate(this.show.dates.find(x => x.id === this.reserved.showDate))
      }
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    setStep (step) {
      this.step = step
      if (this.preview) return false
      if (step === 2) this.$router.push(`/${this.businessUrl}/evento/${this.id}/${this.name}/palco`)
      if (step === 3) this.$router.push(`/${this.businessUrl}/evento/${this.id}/${this.name}/ingressos`)
      if (step === 4) this.$router.push(`/${this.businessUrl}/evento/${this.id}/${this.name}/forma-pagamento`)
      if (step === 5) this.$router.push(`/${this.businessUrl}/evento/${this.id}/${this.name}/checkout`)
    },
    async buyTickets () {
      try {
        if (this.preview) return false
        this.error = []
        this.errorMsg = null
        this.paying = true
        // Buy
        await buy(
          this.tickets.map(x => x.id),
          this.withoutStage || this.show.online ? this.tickets.map(x => x.showPrice) : this.tickets.map(x => x.showPrice.id),
          Number(this.total) > 0 ? this.payment.type : 'free',
          this.payment.creditNumber || null,
          this.payment.creditValidity || null,
          this.payment.creditName || null,
          this.payment.creditCVV || null,
          this.payment.document || null,
          this.payment.addressPostcode || null,
          this.payment.addressState || null,
          this.payment.addressCity || null,
          this.payment.addressSuburb || null,
          this.payment.addressStreet || null,
          this.payment.addressNumber || null,
          this.payment.addressAdjunct || null,
          this.payment.saveCard || false,
          this.payment.installments || null
        )
        let type = null

        if (this.payment.type === 'billet') type = 'pay'
        else if (this.payment.type === 'pix') type = 'pay_pix'
        else type = 'paid'

        type = type !== 'pay' && this.show.online ? 'online' : type
        this.$analytics.event('bought', this.id)
        this.$store.commit('reserved', null)
        this.$store.dispatch('getInvitations')
        this.$router.push(`/usuario?type=${type}`)
        if (type === 'pay' || type === 'pay_pix') {
          this.$message.success('A reserva foi realizada. Aguardando pagamento.', { duration: 3000 })
        } else {
          this.$message.success('Compra realizada com sucesso.', { duration: 3000 })
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          if (Number(this.total) > 0) this.setStep(4)
          else this.setStep(5)
        } else if (data.error === 'Payment error') {
          this.error = ['payment-error']
          this.errorMsg = data.message
          this.setStep(4)
          this.$analytics.event('pay-error', this.id, String(data.message).substr(0, 255))
        } else if (data.error === 'Seats error') {
          this.$store.commit('reserved', null)
          this.error = ['payment-error']
          this.errorMsg = 'Assentos indisponíveis'
          this.setStep(4)
          this.$analytics.event('pay-error', this.id, String(this.errorMsg).substr(0, 255))
          setTimeout(() => {
            this.$router.go()
          }, 2000)
        } else {
          this.error = ['payment-error']
          this.errorMsg = 'Erro interno'
          if (Number(this.total) > 0) this.setStep(4)
          else this.setStep(5)
          this.$analytics.event('pay-error', this.id, 'internal')
        }
        this.paying = false
      }
    },
    async finishDate (showDate) {
      try {
        if (this.showDate && showDate.id !== this.showDate.id) {
          clearInterval(this.timerInterval)
          this.timer = null
        }
        if (!this.preview) this.$analytics.event('show-date', this.id, showDate.id)
        const dataShowDate = await getShowDate(showDate.id)
        this.showPayment = dataShowDate.showPayment
        this.withoutStage = dataShowDate.showDate.find(x => x.id === showDate.id).withoutStage
        this.withSection = dataShowDate.showDate.find(x => x.id === showDate.id).withSection
        this.maxTicketUser = dataShowDate.showDate.find(x => x.id === showDate.id).maxTicketUser
        if (this.withoutStage) {
          this.prices = await getAmountPrices(showDate.id)
          // Add invitations
          this.prices = this.prices.concat(this.getInvitationsFromPrices(this.prices))
          this.setStep(3)
        } else if (this.show.online) {
          this.prices = dataShowDate.prices.filter(x => x.sell === true)
          // Add tables
          this.prices = this.prices.concat(dataShowDate.prices.filter(x => x.ticketType.includes('Mesa ')).map(x => {
            x.tablePrice = x.price * Number(x.ticketType.split(' ')[1])
            return x
          }))
          // Add invitations
          this.prices = this.prices.concat(this.getInvitationsFromPrices(dataShowDate.prices))
          this.setStep(3)
        } else {
          this.prices = dataShowDate.prices.filter(x => x.sell === true)
          // Add tables
          this.prices = this.prices.concat(dataShowDate.prices.filter(x => x.ticketType.includes('Mesa ')).map(x => {
            x.tablePrice = x.price * Number(x.ticketType.split(' ')[1])
            return x
          }))
          // Add invitations
          this.prices = this.prices.concat(this.getInvitationsFromPrices(dataShowDate.prices))
          this.prices.sort((val1, val2) => {
            if (val1.id > val2.id) return 1
            if (val1.id < val2.id) return -1
            return 0
          })
          this.setStep(2)
        }
        this.showDate = showDate
      } catch (error) {
        logger.error(error, this)
      }
    },
    finishStage (tickets, now) {
      if (!tickets) return false
      this.tickets = tickets.map(x => {
        if (x.special) {
          const price = this.prices.find(y => y.special)
          x.showPrice = price
        } else {
          x.showPrice = null
        }
        return x
      }).sort((a, b) => a.seat.localeCompare(b.seat, 'en', { numeric: true }))
      if (!this.preview) this.$analytics.event('seat', this.id, tickets.map(x => x.seat).join(','))
      // Save reserved
      if (this.reserved && !this.preview) {
        const reserved = this.reserved
        reserved.tickets = tickets
        if (this.reserved.show !== Number(this.id)) {
          reserved.show = Number(this.id)
          reserved.showDate = this.showDate.id
          if (this.showDate.withSection) reserved.section = this.showDate.section
        }
        this.$store.commit('reserved', reserved)
      }
      // Set timer
      if (!this.preview) this.setTimer(now, tickets[0].created)
      this.setStep(3)
    },
    async finishNoStage (tickets, now, total) {
      try {
        this.total = total
        this.tickets = tickets
        if (!this.preview) this.$analytics.event('ticket-type', this.id, tickets.map(x => x.showPrice.ticketType).join(','))
        // Save reserved
        if (this.reserved && !this.preview) {
          const reserved = this.reserved
          reserved.tickets = tickets
          if (this.reserved.show !== Number(this.id)) {
            reserved.show = Number(this.id)
            reserved.showDate = this.showDate.id
          }
          this.$store.commit('reserved', reserved)
        }
        // Set timer
        if (!this.preview) {
          this.setTimer(now, tickets[0].created)
          this.customer = await getCustomer()
        }
        if (Number(this.total) > 0) this.setStep(4)
        else this.setStep(5)
      } catch (error) {
        logger.error(error, this)
      }
    },
    async finishTickets (tickets, total) {
      try {
        this.total = total
        this.tickets = tickets
        if (!this.preview) {
          this.$analytics.event('ticket-type', this.id, tickets.map(x => x.showPrice.ticketType).join(','))
          this.customer = await getCustomer()
        }
        if (Number(this.total) > 0) this.setStep(4)
        else this.setStep(5)
      } catch (error) {
        logger.error(error, this)
      }
    },
    finishPayment (payment) {
      if (this.preview) return false
      this.payment = payment
      this.$analytics.event('payment-method', this.id, payment.type)
      this.setStep(5)
    },
    setTimer (now, created) {
      const timer = new Date()
      timer.setHours(0, 15, 0, 0)
      const diff = new Date(now) - new Date(created)
      timer.setMilliseconds(timer.getMilliseconds() - diff)
      this.timerText = `${String(timer.getMinutes()).padStart(2, '0')}:${String(timer.getSeconds()).padStart(2, '0')}`
      this.timer = timer
      clearInterval(this.timerInterval)
      this.timerInterval = setInterval(() => {
        this.timer.setSeconds(this.timer.getSeconds() - 1)
        this.timerText = `${String(this.timer.getMinutes()).padStart(2, '0')}:${String(this.timer.getSeconds()).padStart(2, '0')}`
        if (this.timer.getMinutes() === 0 && this.timer.getSeconds() === 0) {
          clearInterval(this.timerInterval)
          this.$router.push('/')
        }
      }, 1000)
    },
    getInvitationsFromPrices (prices) {
      return prices.reduce((acc, cur) => {
        if (!cur.ticketType.includes('Convite')) return acc
        let type = null
        let discount = 0
        if (cur.ticketType.includes('%')) {
          type = 'percent'
          discount = Number(cur.ticketType.split(' ')[1].replace('%', ''))
        } else if (cur.ticketType.includes('R$')) {
          type = 'value'
          discount = Number(String(cur.ticketType.split(' ')[2]).replace(',', '.'))
        } else {
          type = 'fixed'
          discount = Number(cur.price)
        }
        const count = this.invitations.filter(x => x.expiration === cur.expiration && x.type === type && x.discount === discount).length
        if (count > 0) {
          cur.amount = count
          acc.push(cur)
        }
        return acc
      }, [])
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.finished {
  margin: -8px 0px 0px;
  background-color: #fff472;
  width: 100%;
  padding: 35px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.show-background {
  position: relative;
  margin-top: $menu-height;
}

.show-container {
  max-width: $max-width;
  margin: 0 auto;
  background-color: #fff;
  height: 100%;
  // overflow-y: auto;
}

.show-image {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 40vw;
  max-height: 400px;
}

.show-detail {
  display: flex;
  flex-wrap: wrap;
  padding: $padding-mobile;
  padding-top: 20px;
}

.show-title {
  color: $primary-color;
  font-size: 1.8em;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.show-type {
  color: #333;
  font-size: 1em;
  font-weight: 300;
}

.show-censor {
  position: relative;
  width: 42px;
  height: 42px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 42px;
  color: #fff;
  border-radius: 5px;
  &.censor-0 { background-color: #009700; }
  &.censor-10 { background-color: #00CCFF; }
  &.censor-12 { background-color: #ddb100; }
  &.censor-14 { background-color: #FF6600; }
  &.censor-16 { background-color: #FF0200; }
  &.censor-18 { background-color: #000000; }
  .followed {
    height: 10px;
    bottom: 1px;
    left: 1px;
    right: 1px;
    position: absolute;
    background: #fff;
    color: #555;
    font-size: 0.5em;
    text-transform: uppercase;
    line-height: 12px;
    border-radius: 0 0 5px 5px;
  }
}

.box-2 {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-left: 10px;

  .box-item-1 {
    color: $primary-color;
    font-weight: 500;
    padding: 3px 7px;
  }

  .box-item-2 {
    border-radius: 0 5px 5px 0;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    color: #fff;
    font-weight: 400;
    padding: 3px 7px;
  }
}

.button-confirm {
  color: #fff;
  border: none;
  border: 1px solid $primary-color;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 500;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 7px;
    font-size: 1.2em;
  }
  &:hover {
    i {
      animation-name: ticket-form-button;
      animation-timing-function: ease-in-out;
      animation-duration: 1s;
      animation-iteration-count: 3;
    }
  }
}

.show-timer {
  color: #999;
  font-size: 2em;
  font-weight: 300;
}

.loading-pay {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $primary-color;
  text-transform: uppercase;
  i {
    font-size: 60px;
    color: $primary-color;
    margin-bottom: 20px;
  }
}

.payment-error {
  width: 100%;
  display: flex;
  align-items: center;
  color: $error-color;
  border: 1px solid $error-color;
  border-radius: 5px;
  background-color: rgba(136, 0, 0, 0.1);
  padding: 10px;
  margin-top: 10px;
  i {
    font-size: 3em;
    margin-right: 15px;
  }
  .payment-error-msg {
    span:nth-child(1) {
      display: block;
      font-size: 1em;
    }
    span:nth-child(2) {
      display: block;
      font-size: 0.9em;
      margin: 5px 0;
    }
    span:nth-child(3) {
      display: block;
      font-size: 1em;
    }
  }
}

@media screen and (min-width: $desktop-width) {

  .show-background::before {
    content: "";
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: -20px;
    z-index: -5;
    display: block;
    filter: blur(15px);
    // background-size: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .show-detail {
    padding: $padding-desktop;
  }

}
</style>
<style lang="scss">
  .esconder { display: none; }
</style>
